module.exports = __webpack_public_path__ + "static/img/meeting-meetingplace.239f028f.jpg";